import React from 'react';
import './SignupFooter.css';

// Import the icons we need
import { FaApple, FaAndroid, FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaInstagram } from 'react-icons/fa';

// Data specifically for this footer layout
const footerData = {
  company: ['About CRISHI.com', 'Contact us', 'Help & FAQ', 'Career'],
  products: ['Wheat', 'Rice', 'Sugar', 'Cotton', 'Maize', 'Pulses', 'Spices', 'Vegetables', 
    'Oilseeds', 'Coarse Cereals'],
  region: ['India', 'Argentina', 'Australia', 'Bangladesh', 'Germany', 'Nepal', 'CIS Nations', 'Singapore', 'Turkey', 'United States', 'Vietnam'],
  features: ['Prices', 'Insights', 'Tenders', 'Data & Statistics', 'Reports', 'Info graphics', 'Data licensing', 'Content partnership'],
  help: ['Contact us', 'Terms and Conditions', 'Privacy Policy']
};

const SignupFooter = () => {
  return (
    <footer className="signup-site-footer">
      <div className="signup-footer-content">
        <div className="signup-footer-grid">
          <div className="footer-column">
            <h3>Company</h3>
            <ul>{footerData.company.map((link, i) => <li key={i}><a href="/">{link}</a></li>)}</ul>
          </div>
          <div className="footer-column">
            <h3>Products</h3>
            <ul>{footerData.products.map((link, i) => <li key={i}><a href="/">{link}</a></li>)}</ul>
          </div>
          <div className="footer-column">
            <h3>Region</h3>
            <ul>{footerData.region.map((link, i) => <li key={i}><a href="/">{link}</a></li>)}</ul>
          </div>
          <div className="footer-column">
            <h3>Our Features</h3>
            <ul>{footerData.features.map((link, i) => <li key={i}><a href="/">{link}</a></li>)}</ul>
          </div>
          <div className="footer-column">
            <h3>Help</h3>
            <ul>{footerData.help.map((link, i) => <li key={i}><a href="/">{link}</a></li>)}</ul>
          </div>
        </div>
        <div className="signup-footer-bottom">
          <div className="app-download">
            <span>Download App</span>
            <a href="/" className="app-icon"><FaApple /></a>
            <a href="/" className="app-icon"><FaAndroid /></a>
          </div>
          <div className="social-media">
            <span>Follow us on</span>
            <a href="/" className="social-icon"><FaFacebookF /></a>
            <a href="/" className="social-icon"><FaLinkedinIn /></a>
            <a href="/" className="social-icon"><FaTwitter /></a>
            <a href="/" className="social-icon"><FaYoutube /></a>
            <a href="/" className="social-icon"><FaInstagram /></a>
          </div>
        </div>
        <div className="footer-legal">
          <p className="disclaimer-text">
            <strong>Disclaimer:</strong> CRISHI Technologies Private Limited has taken due care and caution in compilation of content for its web site. Information is just for reference not intended for trading purpose or to address your particular requirement. The content includes facts, views, and opinions are of individuals and not that of the website or its management. We and our content licensors are not giving investment advice, tax advice, legal advice, or other professional advice.
          </p>
          <p className="disclaimer-text">
            Users/Visitors have to make their own decisions based on their own independent enquiries, appraisals, judgement, wisdom and risks. CRISHI and its affiliates, or their employees, directors or agents shall not be liable or responsible for any loss or costs or any action whatsoever arising out of use or relying on the spot prices disseminated.
          </p>
          <div className="copyright-section">
            <span>2009-2025 © CRISHI Technologies Private Limited All Rights Resereved.</span>
            <a href="/">Terms & Conditions</a>
            <a href="/">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SignupFooter;